import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import * as Utils from "../../inc/Utils";

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function UtmTemplateCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [agency, setAgency] = React.useState('');
    let [utm, setUtm] = React.useState('');
    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);
                const resUtm = await Utils.getUtm();
                setUtm(resUtm);
                await onCheckHeadDefault(resUtm);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = () => {
        let name = refName.current.value;
        let items = [];
        let checkboxes = document.getElementsByName('agencyIds[]');
        for (let i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked) {
                items.push({'agencyId': checkboxes[i].value});
            }
        }

        let utmSourceItem =[];
        let utmCheckboxes = document.getElementsByName('utmSourceIds[]');
        for (let i = 0; i < utmCheckboxes.length; i++) {
            if(utmCheckboxes[i].checked) {
                utmSourceItem.push({'utmSourceId': utmCheckboxes[i].value});
            }
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Template");
            refName.current.focus();
        }
        // else if(items.length <= 0) {
        //     toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        // }
        // else if(utmSourceItem.length <= 0) {
        //     toast.error("กรุณาระบุ UTM อย่างน้อย 1 รายการ");
        // }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                name: name,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items,
                                utmSourceItem: utmSourceItem
                            };
                            fetch(Config.url.API_URL +'/api/utmTemplate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/utmTemplate', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onCheckAll = (isChecked, parentId) => {
        utm.map((row, index) => {
            if(parentId === row.id) {
                row.items.map((rs, index2) => {
                    let chkSourceId = 'utmSourceCheck' + rs.id;
                    if(document.getElementById(chkSourceId)) {
                        document.getElementById(chkSourceId).checked = isChecked;
                    }
                });
            }
        });
    };

    const onCheckHead = (parentId) => {
        utm.map((row, index) => {
            if(parentId === row.id) {
                for(let rs of row.items) {
                    let chkSourceId = 'utmSourceCheck' + rs.id;
                    let checked = document.getElementById(chkSourceId).checked;
                    if(checked) {
                        document.getElementById('utmCheck' + row.id).checked = true;
                        break;
                    }
                    else {
                        document.getElementById('utmCheck' + row.id).checked = false;
                    }
                }
            }
        });
    };
    async function onCheckHeadDefault(utmData) {
        let tempData = [...utmData];
        tempData.map((row) => {
            row.headChecked = false;
            for(let rs of row.items) {
                if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_CHECKED || rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED) {
                    row.headChecked = true;
                    return row;
                }
            }
        });
        setUtm(tempData);
    }

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Template</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Template <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="agency" className="form-label">Agency</label>
                                {
                                    agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                        agency.map((row, index) => {
                                            let chkId = 'agencyCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check ms-2">
                                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id}
                                                           id={chkId} />
                                                    <label className="form-check-label" htmlFor={chkId}>
                                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                                    </label>
                                                </div>);
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="utm" className="form-label">UTM</label>
                                {
                                    utm.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                        utm.map((row, index) => {
                                            let chkId = 'utmCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check ms-2 mb-2">
                                                    <input className="form-check-input" name="utmIds[]" type="checkbox" value={row.id} id={chkId} onChange={e => {onCheckAll(e.target.checked, row.id)}} defaultChecked={row.headChecked} />
                                                    <label className="form-check-label fw-bold mb-1" htmlFor={chkId}>
                                                        {row.utmPrefix === 1 ? 'utm_':''}{row.name.toLowerCase()}
                                                    </label>
                                                    {
                                                        row.items.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                                            row.items.map((rs, index2) => {
                                                                let chkSourceId = 'xx';
                                                                let defaultChecked = false;
                                                                if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_CHECKED || rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED) {
                                                                    defaultChecked = true;
                                                                }
                                                                if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED) {
                                                                    chkSourceId = 'yy' + rs.id;
                                                                }
                                                                else {
                                                                    chkSourceId = 'utmSourceCheck' + rs.id;
                                                                }
                                                                return (
                                                                    <div key={index2} className="form-check ms-2">
                                                                        <input className={"form-check-input" + (rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED ? ' unchecked':'')} name="utmSourceIds[]" type="checkbox" value={rs.id} id={chkSourceId} defaultChecked={defaultChecked} onClick={e => {
                                                                            if(rs.defaultCheckType === Utils.UTM_SOURCE_DEFAULT_UNCHECKED) {
                                                                                e.target.checked = true;
                                                                            }
                                                                            else {
                                                                                onCheckHead(row.id);
                                                                            }
                                                                        }} />
                                                                        <label className="form-check-label" htmlFor={chkSourceId}>
                                                                            {rs.name} {rs.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })
                                                    }
                                                </div>
                                            );
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/utmTemplate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 